import React, { createContext, ReactNode, useContext, useState } from "react";
import { FormContext } from "../../../components/Providers/FormProvider/FormProvider";
import { MyInfoContext } from "../../subEvent/content/myInfo/MyInfoProvider";
import { ContextType } from "./KeywordSelectBox";

export interface SafetyContextType {
  pickKeywordIds: Set<number>;
  setPickKeywordIds: React.Dispatch<React.SetStateAction<Set<number>>>;
  isProvided: ContextType;
}

const SafetyContext = createContext<SafetyContextType>(null!);

interface SafetyProviderProps {
  children: ReactNode;
}

export const SafetyProvider: React.FC<SafetyProviderProps> = ({ children }) => {
  const formContext = useContext(FormContext);
  const myInfoContext = useContext(MyInfoContext);

  // local state: formContext, myInfoContext 둘 다 제공되지 않을 때 사용
  const [localPickKeywordIds, setLocalPickKeywordIds] = useState<Set<number>>(
    new Set()
  );

  let safetyValue: SafetyContextType;

  if (formContext) {
    safetyValue = { ...formContext, isProvided: ContextType.FORM };
  } else if (myInfoContext) {
    safetyValue = { ...myInfoContext, isProvided: ContextType.MYINFO };
  } else {
    safetyValue = {
      pickKeywordIds: localPickKeywordIds,
      setPickKeywordIds: setLocalPickKeywordIds,
      isProvided: ContextType.EMPTY,
    };
  }

  return (
    <SafetyContext.Provider value={safetyValue}>
      {children}
    </SafetyContext.Provider>
  );
};

export const useSafetyContext = (): SafetyContextType => {
  const context = useContext(SafetyContext);
  if (!context) {
    throw new Error("useSafetyContext must be used within a SafetyProvider");
  }
  return context;
};
